"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const helpers_1 = require("./helpers");
const input_primary_1 = __importDefault(require("../views/components/ui/input-primary/input-primary"));
const phone_input_mask_1 = __importDefault(require("./phone-input-mask"));
const form_father_1 = __importStar(require("form-father"));
const initModal_1 = require("../views/components/ui/modal/initModal");
const initJsonAndBtnsForModal_1 = require("../views/components/ui/modal/initJsonAndBtnsForModal");
const nav_mob_1 = require("../views/components/sections/nav-mob/nav-mob");
const slider_wrapper_1 = require("../views/components/ui/slider-wrapper/slider-wrapper");
const checkbox_primary_1 = require("../views/components/ui/checkbox-primary/checkbox-primary");
const scroll_father_1 = require("scroll-father");
const initTabsWithSliders_1 = require("../views/components/ui/tab/initTabsWithSliders");
const map_1 = require("../views/components/sections/map/map");
const sidenav_1 = __importDefault(require("../views/components/sections/sidenav/sidenav"));
const photo_swiper_initer_1 = require("../views/components/ui/photo-swiper/photo-swiper-initer");
const accordion_1 = __importDefault(require("../views/components/ui/accordion/accordion"));
const custom_select_1 = require("../views/components/ui/custom-select/custom-select");
const products_catalog_1 = __importDefault(require("../views/components/sections/products-catalog/products-catalog"));
const seo_1 = require("../views/components/sections/seo/seo");
const banner_1 = require("../views/components/sections/banner/banner");
const product_card_1 = __importDefault(require("../views/components/blocks/product-card/product-card"));
const product_detail_1 = __importDefault(require("../views/components/sections/product-detail/product-detail"));
const initHints_1 = require("../views/components/ui/hint/initHints");
const scrollbar_1 = require("../views/components/ui/scrollbar/scrollbar");
const scrollbar_simplebar_1 = require("../views/components/ui/scrollbar/scrollbar-simplebar");
const cookie_modal_1 = __importDefault(require("../views/components/sections/cookie-modal/cookie-modal"));
const franchise_faq_1 = require("../views/components/sections/franchise-faq/franchise-faq");
const first_screen_1 = __importDefault(require("../views/components/sections/first-screen/first-screen"));
const ya_invisible_captcha_client_1 = __importDefault(require("ya-invisible-captcha-client"));
form_father_1.default.setDefaultParams({
    loaderColor: 'currentColor',
    inputSelector: '.input, [data-ya-captcha-token-input]',
    inputWrapperSelector: 'input-primary, .checkbox__wrapper, select-primary, [data-ya-captcha-token-input-wrapper]',
    onBeforeValidate: form => {
        if (form.$el.hasAttribute('data-ya-captcha-form')) {
            window.$yaCurrentForm = form.$el;
        }
    },
    onResponse: (_, form) => {
        if (window.$yaCurrentForm === form.$el) {
            window.captcha.reset();
            window.$yaCurrentForm.querySelector('[data-ya-captcha-token-input]').value = '';
            window.$yaCurrentForm = null;
        }
    },
});
const $header = document.getElementById('header');
// ИСПРАВЛЯЕМ БАГ BX в компоненте nineseven.favorite
window.isJQueryLoaded = () => Promise.reject();
(0, helpers_1.initializationsTasksWithYield)([
    () => {
        (0, scroll_father_1.initScrollDirectionTracking)();
        (0, scroll_father_1.trackScrollState)({
            attribute: 'data-scrolled',
            element: document.body,
        });
        (0, scroll_father_1.smootherAllAnchorLinks)();
    },
    () => {
        (0, nav_mob_1.initNavMob)();
        (0, sidenav_1.default)();
    },
    // () => {
    // 	const $m = document.getElementById('messages');
    // 	if ($m) {
    // 		initMessages($m);
    // 	}
    // },
    () => {
        const $productDetail = document.querySelector('.product-detail');
        if ($productDetail)
            (0, product_detail_1.default)($productDetail);
    },
    () => {
        /* Инициализация кастомных элементов */
        customElements.define('bm-accordion', accordion_1.default);
        customElements.define('custom-select', custom_select_1.CustomSelect);
        customElements.define('input-primary', input_primary_1.default);
        (0, checkbox_primary_1.initAllCheckboxPrimary)();
    },
    () => {
        /* Инициализация маски номера телeфона */
        const phoneInputs = document.querySelectorAll('input[data-tel-input]');
        phoneInputs.forEach(phone_input_mask_1.default);
        (0, form_father_1.registerValidator)('tel', v => (0, helpers_1.isPhoneValid)(v), 'Введите корректный номер телефона', { override: true });
    },
    () => {
        /* Инициализация карточек товаров */
        for (const $productCard of document.getElementsByClassName('product-card')) {
            (0, product_card_1.default)($productCard);
        }
    },
    () => {
        (0, scrollbar_1.initSrollbarMouseHandler)();
        (0, scrollbar_simplebar_1.initSrollbarSimplebarAndMouseHandler)();
    },
    () => {
        const SUPPORTED_LANGS = ['tr', 'ru', 'en', 'be', 'kk', 'tt', 'uk', 'uz'];
        function isCaptchaLang(x) {
            return SUPPORTED_LANGS.includes(x);
        }
        const htmlLang = (document.documentElement.lang || '').toLowerCase();
        const lang = isCaptchaLang(htmlLang) ? htmlLang : 'ru';
        window.captcha = new ya_invisible_captcha_client_1.default({
            sitekey: window.ya_sitekey,
            callback: token => {
                if (window.$yaCurrentForm) {
                    const $tokenInput = window.$yaCurrentForm.querySelector('[data-ya-captcha-token-input]');
                    if ($tokenInput) {
                        $tokenInput.value = token;
                        window.$yaCurrentForm.requestSubmit();
                    }
                }
            },
            lang,
            debug: process.env.NODE_ENV === 'development',
            // test: true,
        });
        document.querySelectorAll('[data-ya-captcha-token-input-wrapper]').forEach($inputToken => {
            // eslint-disable-next-line no-param-reassign
            $inputToken.showError = () => window.captcha.execute();
        });
    },
    () => {
        var _a;
        /* Инициализация всех автоинициализируемых форм */
        (_a = document.querySelectorAll('[data-form-auto-init-mini]')) === null || _a === void 0 ? void 0 : _a.forEach(($form) => {
            new form_father_1.default($form, {
                // @note исправление бага скроллинга в формах (смещения макета при overflow: hidden)
                scrollToFirstErroredInput: false,
                loaderColor: 'currentColor',
                onResponseSuccess(b, f) {
                    window.modal.open('#modalThanks');
                    f.clearInputs();
                },
            });
        });
        const $formDownload = document.getElementById('callbackFormDownload');
        new form_father_1.default($formDownload, {
            // @note исправление бага скроллинга в формах (смещения макета при overflow: hidden)
            scrollToFirstErroredInput: false,
            loaderColor: 'currentColor',
            onResponseSuccess(b, f) {
                window.modal.open('#modalThanksDownload');
                const $linkDownloadPdf = document.querySelector('#modalThanksDownload .modal-thanks__btn');
                var linkAtNotDOM = document.createElement('a');
                linkAtNotDOM.setAttribute('href', $linkDownloadPdf.href);
                linkAtNotDOM.setAttribute('download', '');
                linkAtNotDOM.click();
                f.clearInputs();
            },
        });
    },
    () => {
        (0, slider_wrapper_1.initDefaultSliders)();
    },
    () => {
        /* Инициализация табов в секциях */
        const sectionsWithTabs = document.querySelectorAll('.section--tabs');
        if (sectionsWithTabs) {
            (0, initTabsWithSliders_1.initTabsWithSliders)(sectionsWithTabs);
        }
    },
    () => {
        const $franchiseFaq = document.getElementById('franchiseFaq');
        if ($franchiseFaq) {
            (0, franchise_faq_1.initFranchiseFaq)($franchiseFaq);
        }
    },
    () => {
        const $mapSection = document.getElementById('mapSection');
        if ($mapSection) {
            (0, map_1.initMapOnScroll)($mapSection, '/mapCities.json', 'https://api-maps.yandex.ru/2.1/?lang=ru_RU&apikey=3269beed-8b71-43bf-91f7-d80565f15bd5');
        }
    },
    () => {
        const $seoAll = document.querySelectorAll('.seo');
        if ($seoAll.length) {
            $seoAll.forEach($seo => {
                (0, seo_1.initSeo)($seo);
            });
        }
    },
    () => {
        const $banner = document.querySelector('.banner');
        if ($banner)
            (0, banner_1.initBanner)($banner);
    },
    () => {
        (0, initModal_1.initModal)();
        (0, helpers_1.initBtnsDataForAnotherElements)();
        (0, initJsonAndBtnsForModal_1.initJsonAndBtnsForModal)('eventsBtnsWrapper', 'eventModal', [
            {
                id: 'eventModalImg',
                key: 'img.url',
                what: 'src',
            },
            {
                id: 'eventModalDate',
                key: 'date',
                what: 'textContent',
            },
            {
                id: 'eventModalTitle',
                key: 'title',
                what: 'textContent',
            },
            {
                id: 'eventModalText',
                key: 'text',
                what: 'innerHTML',
            },
        ]);
        // @todo-prod убрать?
        // (window as any).modal.open('#modalThanks');
        // (window as any).modal.open('#franchiseModal');
        // (window as any).modal.open('#eventModal');
    },
    () => {
        (0, photo_swiper_initer_1.initPhotoSwiper)();
    },
    () => {
        const $productsCatalog = document.querySelector('.products-catalog');
        if ($productsCatalog)
            (0, products_catalog_1.default)($productsCatalog, $header);
    },
    () => {
        const $firstScreen = document.querySelector('.first-screen');
        if ($firstScreen)
            (0, first_screen_1.default)($firstScreen);
    },
    () => {
        (0, initHints_1.initHints)();
    },
    () => {
        const $cookieModal = document.getElementById('cookies');
        if ($cookieModal)
            (0, cookie_modal_1.default)($cookieModal);
    },
]);
